import { TypeOperation } from '../../interfaces/TypeOperation/TypeOperation'
import { TypeOperationAction } from '../actions/TypeOperationActions'
import { GET_TYPE_OPERATION_EXITO } from '../types/typeOperationActionstypes'

export interface TypeOperationState {
  typeOperationState: {
    typeOperation?: TypeOperation[]
    error?: string | undefined
  }
}

const initialState: TypeOperationState = {
  typeOperationState: { typeOperation: [], error: '' }
}

export const typeOperationReducer = (
  state: TypeOperationState = initialState,
  action: TypeOperationAction
): TypeOperationState => {
  if (action.type === GET_TYPE_OPERATION_EXITO) {
    return {
      ...state,
      typeOperationState: {
        typeOperation: action.typeOperation,
        error: action.error
      }
    }
  }
  return state
}
